// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-container ion-button {
  margin-left: auto;
  font-size: 14px;
  height: auto;
  line-height: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/field-group/field-group.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AACJ","sourcesContent":[".label-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.label-container ion-button {\r\n    margin-left: auto;\r\n    font-size: 14px; \r\n    height: auto; \r\n    line-height: normal; \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
